import styled from 'styled-components';
import background from '../assets/G3.png'


export const HomeContainer = styled.div`
    height:100vh;
    display: flex;
    align-items: center;
    overflow-y: hidden;
    background:#1D1E22;
`;


export const Container = styled.div`
    width:1200px;
    height:100%;
    display: flex;
    flex-direction: row;
    margin: auto;
`;

export const MainTitle = styled.p`
    font-size:100px;
  font-family: 'Dancing Script', cursive;
  font-weight: 700;
  animation: flow 2.5s ease-in-out infinite;
  background: linear-gradient(-60deg, #81c73f, #5cd671, #e73c7e, #3fcbcf);
  background-size: 300%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  @keyframes flow {
    0%{
      background-position: 0 50%;
    }
    50%{
      background-position: 50% 100%;
    }
    100%{
      background-position: 0 50%;
    }
    
  }

  @media screen and (max-width: 1000px){
    font-size:60px;
    }
  `;


export const MainCaption = styled.p`
    margin: 0px;
    padding: 0px;
    font-size: 20px;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    animation: flow 2.5s ease-in-out infinite;
    background: linear-gradient(-60deg, #81c73f, #5cd671, #e73c7e, #3fcbcf);
    background-size: 300%;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;

    @keyframes flow {
        0%{
        background-position: 0 50%;
        }
        50%{
        background-position: 50% 100%;
        }
        100%{
        background-position: 0 50%;
        }

        @media screen and (max-width: 1000px){
            font-size:15px;
        }
    
`;

export const GradientExplore = styled.div`
    width:50%;
    height: 100%;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 1000px){
        width:100%;
    }
`;
export const GradientTitle = styled.div`
      text-align: center;
`;

export const GradientButton = styled.div`
      margin: 25px; 
      cursor: pointer;
`;
    
export const Button = styled.button`
    margin: 10px;
    padding: 15px 45px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    font-size: 15px;            
    cursor:pointer;
    border-radius: 10px;
    display: block;
    border: 0;
    background-image: linear-gradient(to right, #FF512F 0%, #DD2476  51%, #FF512F  100%)};
    
    &:hover{
        background-position: right center; /* change the direction of the change here */
        color: #fff;
        text-decoration: none;
      }
    `;
    

export const GradientImage = styled.div`
    width:50%;
    height:100%;
    display:flex;
    justify-content: flex-end;

    @media screen and (max-width: 1000px){
        display:none;
    }
    `;
    
  
export const Image = styled.div`
    width:100%;
    height: 100%;
    background-image: url(${background});
    background-size:cover;
    background-position: center;
    background-clip: content-box;
    `;

